import formatDate from './formatDate'

export default formatDate
